export default __webpack_public_path__ + "static/lsa-devices-bd18601c82427c85ecf9ad52599d3438.jpg";